export default "__VITE_ASSET__Dexs4Q4$__"